import React, { useState } from "react";
import { useQuery } from "@apollo/client/react";
import orderBy from "lodash/orderBy";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import { WAREHOUSE_PROJECTS } from "../../constants/graphql/queries";

export default function ProjectFilter({ selected, setSelected, warehouseId }) {
  const [searchTerm, setSearchTerm] = useState("");
  const { data: { warehouse = {} } = {} } = useQuery(WAREHOUSE_PROJECTS, {
    variables: { id: warehouseId },
  });

  const projects = warehouse.projects
    ? orderBy(warehouse.projects, "name").map(({ id, name }) => [id, name])
    : [];

  const filteredProjects = projects.filter(([projectId, projectName]) =>
    (projectName || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Box sx={{ p: 2, borderBottom: "1px solid #e0e0e0" }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {filteredProjects.map(([projectId, projectName]) => (
        <MenuItem
          key={projectId}
          sx={{ 
            fontSize: 15,
            minHeight: 48,
            py: 1.5,
            px: 2,
          }}
          onClick={() => {
            setSelected(prevState =>
              prevState.includes(projectId)
                ? prevState.filter(v => v !== projectId)
                : [...prevState, projectId]
            );
          }}
        >
          <Box my={0} ml={-1}>
            <Checkbox 
              size="medium"
              checked={selected.includes(projectId)} 
              onChange={e => {}} 
              value="" 
            />
          </Box>
          {projectName}
        </MenuItem>
      ))}
    </>
  );
}
